import apiService from '@/state/services/Api'

const keys = {
  namespaced: true,
  state: {
    pk: 'comm_mod_uuid',
  },
  getters: {
    pk(state) {
      return state.pk
    },
  },
  mutations: {},
  actions: {
    async get({state, commit}) {
      const response = await apiService.query(`keys/`)
      return response
    },

    getTransfers({state, commit}) {
      return apiService.query(`transfers/`).then(data => {
        return data
      })
    },

    getTransferKeys({state, commit}, id) {
      return apiService.get(`transfers/${id}/`).then(data => {
        return data
      })
    },
    async getDeviceKeys(context, uuid){
        try{
          const keys = await apiService.get(`/keys/${uuid}`)
          return keys
        }catch{
          
        }
        // try{
        //   const keys = await apiService.get(`v1/keys/?serial=${payload}`)
        //   console.log(keys.results[0])
        //   return keys.results[0].keys
        // }catch(error){
        //   return error
        // }
    },

    export({state, commit, rootState}, format) {
      const config = {responseType: 'blob'}

      if (format === 'json') {
        config.headers = {Accept: 'application/json; indent=4'}
      }

      // if (!isEmpty(store.state.keys.searchList)) {
      //   return api.post(`keys/export.${format}`, store.state.keys.searchList, config)
      // }

      config.params = rootState.route.query
      return apiService.get(`keys/export.${format}`, config).then(data => {
        return data
      })
    },

    transfer(context, payload) {
      return apiService.post(`transfers/`, payload).then(data => {
        return data
      })
    },

    async search(context, payload) {
      try {
        const data = await post(`keys/search`, payload)
        context.commit(SET_KEY_LIST, data)
        context.commit(SET_KEY_SEARCH_LIST, payload)
        return data
      } catch (error) {
        throw error
      }
    },

    async remove(context, payload) {
      // key_uuid_list
      try {
        // context.commit(SET_KEY_LIST, data)
        return await post(`keys/remove`, payload)
      } catch (error) {
        throw error
      }
    },
  },
}

export default keys
